import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DialerCaseDataSlice {
    isCaseCompleted: boolean;
    currentCaseID: string;
    currentClientReferenceID: string;
}

const initialState: DialerCaseDataSlice = {
    isCaseCompleted: true,
    currentCaseID: '',
    currentClientReferenceID: ''
}

export const dialerCaseDataSlice = createSlice({
    name: 'dialerCaseData',
    initialState,
    reducers: {
        loadIsCaseCompleted: (state, action: PayloadAction<boolean>) => {
            state.isCaseCompleted = action.payload;
        },
        loadCurrentCaseID: (state, action: PayloadAction<string>) => {
            state.currentCaseID = action.payload;
        },
        loadCurrentClientReferenceID: (state, action: PayloadAction<string>) => {
            state.currentClientReferenceID = action.payload;
        },
    }
});

export const {
    loadIsCaseCompleted,
    loadCurrentCaseID,
    loadCurrentClientReferenceID
} = dialerCaseDataSlice.actions;

export default dialerCaseDataSlice.reducer;